'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Grid from '@enlighten/design-system/dist/Grid';
import Tabs from '@enlighten/design-system/dist/Tabs';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Phone1Image from '../../assets/images/rtu/rtu-sec-05-phone-01.png';
import Phone2Image from '../../assets/images/rtu/rtu-sec-05-phone-02.png';
// @ts-ignore
const SliderComponent = !!Slider.default ? Slider.default : Slider;
export default function RtuSection5() {
    const [index, setIndex] = useState(0);
    const sliderRef = useRef(null);
    useEffect(() => {
        sliderRef.current?.slickGoTo(index);
    }, [index]);
    return (_jsxs(Grid, { container: true, direction: { xs: 'column', md: 'row' }, justifyContent: "center", alignItems: "center", gap: { xs: 4, md: '50px' }, width: "100%", paddingX: 2, paddingBottom: { xs: '60px', md: '140px' }, sx: {
            '& img': {
                width: '100%',
                height: 'auto',
            },
        }, children: [_jsxs(Grid, { flex: 1, textAlign: { xs: 'center', md: 'left' }, maxWidth: 540, children: [_jsx(Typography, { fontSize: { xs: 24, md: 40 }, fontWeight: 700, textAlign: { xs: 'center', md: 'left' }, lineHeight: { xs: '34px', md: '52px' }, color: "common.black", marginBottom: { xs: '10px', md: 2 }, children: '365일 내내 빅데이터 기반으로\n발전소를 분석해 드려요.' }), _jsx(Typography, { display: { xs: 'none', md: 'block' }, fontSize: 18, lineHeight: "28px", color: "grey.A400", children: '특허받은 빅데이터 분석 기술을 기반으로 발전소의 상태를 분석한\n주간 보고서(매주), 일일 리포트(매일)를 받아볼 수 있어요.' }), _jsx(Typography, { display: { xs: 'block', md: 'none' }, fontSize: 14, lineHeight: "24px", color: "grey.A400", children: '특허받은 빅데이터 분석 기술을 기반으로 발전소의 상태를\n분석한 주간 보고서(매주), 일일 리포트(매일)를\n받아볼 수 있습니다.' }), _jsx(Tabs, { value: index, onChange: (_, value) => {
                            setIndex(value);
                        }, TabIndicatorProps: {
                            sx: {
                                bottom: { xs: 4, md: 0 },
                                bgcolor: 'common.white',
                                height: { xs: 'calc(100% - 8px)', md: '100%' },
                                borderRadius: 999,
                                boxShadow: '0 2px 8px -2px #0000000D, 0 1px 4px -1px #00000012, 0 0 1px 0 #00000014',
                            },
                        }, items: [
                            {
                                disableRipple: true,
                                value: 0,
                                label: '주간 보고서',
                            },
                            {
                                disableRipple: true,
                                value: 1,
                                label: '일일 리포트',
                            },
                        ], sx: {
                            alignItems: 'center',
                            bgcolor: '#0000000A',
                            width: 'fit-content',
                            height: { xs: 48, md: 54 },
                            borderRadius: 999,
                            marginTop: { xs: 3, md: 2 },
                            padding: '4px',
                            '.MuiTab-root': {
                                color: 'grey.800',
                                fontSize: { xs: 16, md: 18 },
                                height: 'inherit',
                                borderRadius: 999,
                                paddingX: '36.5px',
                                zIndex: 999,
                                '&.Mui-selected': {
                                    color: '#262626',
                                },
                            },
                        } })] }), _jsx(Grid, { flex: 1, maxWidth: { md: 540 }, width: "100%", paddingX: 1, children: _jsxs(SliderComponent, { ref: sliderRef, waitForAnimate: false, swipe: false, infinite: false, prevArrow: _jsx(_Fragment, {}), nextArrow: _jsx(_Fragment, {}), children: [_jsx(Image, { src: Phone1Image, alt: "" }), _jsx(Image, { src: Phone2Image, alt: "" })] }) })] }));
}
